module.exports = __webpack_public_path__ + "img/default-logo.aab15cf3.svg";